import styled from 'styled-components';

export const ContentGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-bottom: 24px;
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const MainContent = styled.div`
  display: contents;
`;

export const CardsSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ChartSection = styled.div`
  flex: 2 1 60%;
  width: 100%;
  min-width: 300px;
  background: white;
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #f3f4f6;
  max-height: 600px;
  overflow: hidden;

  h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.text || '#1f2937'};
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .chart-container {
    width: 100%;
    height: 400px;
    overflow: hidden;
    position: relative;

    /* Garantir que o gráfico não saia do container */
    & > div {
      width: 100% !important;
      max-width: 100% !important;
    }

    /* Estilos específicos para o canvas do gráfico */
    canvas {
      max-width: 100% !important;
    }
  }
`;

export const SidebarContent = styled.div`
  flex: 1 1 30%;
  min-width: 280px;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-end;
    margin-top: 16px;
  }
`;
